import { render, staticRenderFns } from "./ModalConfigIngenes.vue?vue&type=template&id=f4c48ca0&scoped=true"
import script from "./ModalConfigIngenes.vue?vue&type=script&lang=js"
export * from "./ModalConfigIngenes.vue?vue&type=script&lang=js"
import style0 from "./ModalConfigIngenes.vue?vue&type=style&index=0&id=f4c48ca0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4c48ca0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node-apps/im.ingenes.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f4c48ca0')) {
      api.createRecord('f4c48ca0', component.options)
    } else {
      api.reload('f4c48ca0', component.options)
    }
    module.hot.accept("./ModalConfigIngenes.vue?vue&type=template&id=f4c48ca0&scoped=true", function () {
      api.rerender('f4c48ca0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Admin/Ingenes/ModalConfigIngenes.vue"
export default component.exports